import {Component, Host, h, Prop, State, Listen} from '@stencil/core';
import {ConfirmedCompanyEvent} from "../search-company-form/search-company-form";
import {CompanyViewModel} from "@modules/onBoarding/presentation/viewModel/CompanyViewModel";
import {OnboardingViewModel} from "@modules/onBoarding/presentation/viewModel/OnboardingViewModel";

export type ViewType = 'searchCompany'|'alreadyRegistered'|'userRegistration'|'companyRegistration';

@Component({
    tag: 'onboarding-views',
    styleUrl: 'onboarding-views.css',
    scoped: true,
})
export class OnboardingViews {

    @Prop() viewModel: string;

    @State() view: ViewType = 'searchCompany';

    private confirmedCompany: CompanyViewModel;

    private onboardingViewsDTO: OnboardingViewModel;

    async componentWillLoad() {
        this.onboardingViewsDTO = JSON.parse(this.viewModel);
    }

    @Listen('confirmedCompany')
    handleConfirmedCompany(confirmedCompanyEvent: CustomEvent<ConfirmedCompanyEvent>) {
        this.confirmedCompany = confirmedCompanyEvent.detail.confirmedCompany;

        if (confirmedCompanyEvent.detail.isAlreadyRegistered) {
            this.view = 'alreadyRegistered';
            return;
        }

        this.view = 'userRegistration';
    }

    @Listen('notListedCompany')
    handleNotListedCompany() {
        this.view = 'companyRegistration';
    }

    renderView() {
        const viewRenderers: Record<ViewType, () => any> = {
            'searchCompany': this.renderSearchCompanyView.bind(this),
            'alreadyRegistered': this.renderAlreadyRegisteredView.bind(this),
            'userRegistration': this.renderUserRegistrationView.bind(this),
            'companyRegistration': this.renderCompanyRegistrationView.bind(this)
        };

        return viewRenderers[this.view]();
    }

    renderSearchCompanyView() {
        return (
            <search-company-view
                viewModel={this.onboardingViewsDTO.searchCompanyView}
            ></search-company-view>
        );
    }

    renderAlreadyRegisteredView() {
        return (
            <already-registered-view
                viewModel={this.onboardingViewsDTO.alreadyRegisteredView}
                company={this.confirmedCompany}
            ></already-registered-view>
        );
    }

    renderUserRegistrationView() {
        return (
            <user-registration-view
                viewModel={this.onboardingViewsDTO.userRegistrationView}
                company={this.confirmedCompany}
            ></user-registration-view>
        );
    }

    renderCompanyRegistrationView() {
        return (
            <company-registration-view viewModel={this.onboardingViewsDTO.companyRegistrationView}></company-registration-view>
        );
    }

    render() {
        return (
            <Host>
                {this.renderView()}
            </Host>
        );
    }
}
